import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { useCallback } from 'react';
import { MenuItemContainer } from '../../../components/menuItemContainer';
import { addMessageBox } from '../../../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { isLocalhostEnvironment } from '../../../utils/utils';
// TODO: Add the availability of the rename admin action to the 'player_info:' server outbound and don't hard-code the IDs here:
const RENAME_ENABLED_ADMIN_IDS = [
    1, // ZenBlender
    1412 // Rockworker
];
export const PlayerRenameAdminMenuItemContainer = ({ playerIdName, closeMenu }) => {
    const dispatch = useAppDispatch();
    const isSelfAdmin = useAppSelector((state) => state.selfData.isAdmin);
    const myPlayerId = useAppSelector((state) => state.selfData.id);
    const isLobbyScene = useAppSelector((state) => state.scene.roomSceneType === 'lobby');
    const onClick = useCallback(() => {
        dispatch(addMessageBox({ type: 'rename-player-admin-action', player: playerIdName }));
    }, [dispatch, playerIdName]);
    if (!isSelfAdmin || myPlayerId === undefined) {
        return null;
    }
    if (!isLocalhostEnvironment() && !RENAME_ENABLED_ADMIN_IDS.includes(myPlayerId)) {
        return null;
    }
    if (!isLobbyScene) {
        return (_jsx(MenuItemContainer, { label: 'Can Rename in Lobby', svgIconComponent: EditRoundedIcon, onClick: onClick, closeMenu: closeMenu, disabled: true }));
    }
    return (_jsx(MenuItemContainer, { label: 'Rename Player', svgIconComponent: EditRoundedIcon, onClick: onClick, closeMenu: closeMenu }));
};
